var UitkBadgeSize = {
    SMALL: 'small',
    LARGE: 'large'
};
var UitkBadgeStandardThemes = {
    STANDARD: 'standard',
    EMPHASIS: 'emphasis',
    INFO: 'info',
    FEATURED: 'featured',
    BRAND: 'brand',
    WARNING: 'warning',
    POSITIVE: 'positive'
};
var UitkBadgeLoyaltyThemes = {
    LOW: 'lowtier',
    MID: 'midtier',
    HIGH: 'hightier',
    EXTRAHIGH: 'extrahightier',
    GLOBAL_STANDARD: 'global-standardtier',
    GLOBAL_LOW: 'global-lowtier',
    GLOBAL_MIDDLE: 'global-middletier',
    GLOBAL_HIGH: 'global-hightier',
    GLOBAL_EXTRAHIGH: 'global-extrahightier',
    VIP: 'vip'
};
var UitkBadgeProgramThemes = {
    DEAL: 'deal',
    MEMBER: 'member',
    TRIP_SAVINGS: 'trip',
    SUPPLIER_PROMO: 'supplierpromo',
    VIRTUAL_MARKET_COACH: 'vmc'
};
var UitkBadgeNotificationThemes = {
    UNREAD: 'unread',
    ACTIVITY: 'activity',
    ACTION: 'action',
    DEFAULT: 'default',
    INVERSE: 'inverse'
};

export { UitkBadgeLoyaltyThemes, UitkBadgeNotificationThemes, UitkBadgeProgramThemes, UitkBadgeSize, UitkBadgeStandardThemes };
